<style lang="scss"></style>

<template>
  <div id="modal-remove-composicao" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">ATENÇÃO!</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-block shadow0 m0 pb0">
                <div class="title-block" v-if="composicao">
                  <h3 class="title adasd">
                    Tem certeza que deseja remover o tipo de composição
                    <span
                      class="text-info"
                    >{{ composicao.nome }}</span>?
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="remover"
            :disabled="enviando"
          >{{ enviando ? "REMOVENDO..." : "SIM" }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">NÃO</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, closeLoading } from '../../../helpers';
import TipoComposicaoService from '../../../services/TipoComposicaoService';

export default {
  name: 'modal-remove-composicao',
  data() {
    return {
      enviando: false,
      composicao: null,
    };
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-remove-composicao').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.removeComposicaoId = null;
    });

    if (this.$parent.removeComposicaoId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.composicao = null;
    },
    async load() {
      try {
        showLoading();

        if (this.$parent.removeComposicaoId === 0) return;

        this.composicao = await TipoComposicaoService.findById(
          this.$parent.removeComposicaoId,
        );
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-remove-composicao').modal('show');
      }
    },
    async remover() {
      try {
        this.enviando = true;

        showLoading();

        await TipoComposicaoService.remove(this.composicao.id);

        this.$toast.success('Tipo de composição removido com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-remove-composicao').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
